/** Effective placement payout model: marketplace/dynamic follow the offer, rewarded stays CPI. */

export function getEffectivePlacementPayoutType({
  payoutType,
  payoutMode,
  offerPayoutType,
  isMarketplace,
  publisherMediaType,
}) {
  if (isMarketplace && publisherMediaType === 'rewarded') {
    return 'CPI';
  }

  if (isMarketplace || payoutMode === 'dynamic') {
    return offerPayoutType || payoutType;
  }

  return payoutType;
}
